import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ActivationHelper {
  localeString: string = "DD-MMM-YY"; //  HH:mm:ss
  constructor() {}

  retrieveData(order: any, columnProperty: string): string {
    if (order[columnProperty]) {
      //"20190612"
      return this.formatDateAndTime(order, columnProperty);
    }
    return "NOW";
  }

  private formatDateAndTime(order: any, columnProperty: string): string {
    let actDate: string = order[columnProperty].activationDate;
    let actTime: string = order[columnProperty].activationTime;
    let timezone: string = order[columnProperty].timezone;
    if (actTime != undefined && actTime.length == 4) {
      actTime = actTime.substr(0, 2) + ":" + actTime.substr(2, 2);
    }
    if (actDate && actTime && timezone)
      return (
        CubiqTS.moment(actDate, "YYYY-MM-DD").format(this.localeString) +
        " " +
        actTime +
        " " +
        timezone
      );
    return "-";
  }
}
